var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,2H3C2.448,2,2,2.448,2,3v18c0,0.553,0.448,1,1,1h6v-6h6v6h6c0.552,0,1-0.447,1-1V3   C22,2.448,21.552,2,21,2z M7,12H5v-2h2V12z M7,8H5V6h2V8z M11,12H9v-2h2V12z M11,8H9V6h2V8z M15,12h-2v-2h2V12z M15,8h-2V6h2V8z    M19,12h-2v-2h2V12z M19,8h-2V6h2V8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.5bd7e7ea9b7fa5125407465efca86921.svg";
export { ForwardRef as ReactComponent };